import { z } from 'zod';

export const compactParamsSchema = z.object({
  showProfilePicture: z.boolean().default(false),
  accentColor: z.string().default('#00B48A'),
  spacing: z.enum(['compact', 'normal', 'aere']).default('normal'),
});

export type CompactParams = z.infer<typeof compactParamsSchema>;

export const compactDefaults: CompactParams = {
  showProfilePicture: false,
  accentColor: '#00B48A',
  spacing: 'normal',
};
